import axios from "axios";

async function apiCall(url, verb, payload) {
  const token = localStorage.getItem("userToken");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const { REACT_APP_BASE_URL_PROD, NODE_ENV } = process.env;
  let apiUrl = url;

  if (NODE_ENV === "production") {
    apiUrl = REACT_APP_BASE_URL_PROD.concat(apiUrl);
  }

  function call() {
    switch (verb) {
      case "get":
        return axios.get(apiUrl, config);
      case "post":
        return axios.post(apiUrl, payload, config);
      default:
        return axios.get(apiUrl, config);
    }
  }

  try {
    console.time();
    const resp = await call();
    console.timeEnd();

    const { data } = resp;
    return data;
  } catch (error) {
    return error;
  }
}

export default apiCall;
